import React from "react";
// import { Table } from "evergreen-ui";
import Component from "@reactions/component";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import Lottie from "lottie-react-web";
import { toast } from "react-toastify";
import * as GrIcons from "react-icons/gr";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import { withStyles, makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
// import { createMuiTheme } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

import Paper from "@mui/material/Paper";
import * as AiIcons from "react-icons/ai";
import * as CgIcons from 'react-icons/cg'
import CircularProgress from "@mui/material/CircularProgress";
import Table from "react-bootstrap/Table";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Tooltip from '@mui/material/Tooltip';
import helpers from "../../assets/js/helper";
import axios from "../../assets/js/AxiosInterceptors";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    width:'100%',
    height:'100%'
  },
}))(Tooltip);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
// const materialTheme = createMuiTheme({
//   palette: {
//     primary: {
//       main: "#2e6b95",
//     },
//   },
//   overrides: {
//     MuiPickersToolbar: {
//       toolbar: {
//         //   backgroundColor: lightBlue.A200,
//       },
//     },
//     MuiPickersCalendarHeader: {
//       switchHeader: {
//         // backgroundColor: lightBlue.A200,
//         // color: "white",
//       },
//     },
//     MuiPickersBasePicker: {
//       pickerView: {
//         width: "100%",
//         maxWidth: "100%",
//       },
//     },
//     MuiPickersDay: {
//       //     day: {
//       //       color: lightBlue.A700,
//       //     },
//       //     daySelected: {
//       //       backgroundColor: lightBlue["400"],
//       //     },
//       //     dayDisabled: {
//       //       color: lightBlue["100"],
//       //     },
//       //     current: {
//       //       color: lightBlue["900"],
//       //     },
//       //   },
//       //   MuiPickersModal: {
//       //     dialogAction: {
//       //       color: lightBlue["400"],
//       //     },
//     },
//   },
// });
// const useStyles = makeStyles((theme) => ({
//   appBar: {
//     position: "relative",
//     backgroundColor: "#2e6b95",
//   },
//   title: {
//     marginLeft: theme.spacing(2),
//     flex: 1,
//   },
//   oddRow: {
//     borderRadius: "5px",
//     marginTop: theme.spacing(1),
//     padding: theme.spacing(1),

//     backgroundColor: "#2e6b95",
//   },
//   evenRow: {
//     borderRadius: "5px",
//     marginTop: theme.spacing(1),
//     padding: theme.spacing(1),
//     backgroundColor: "#e7e8e8",
//   },
//   generalRow: {
//     borderRadius: "5px",
//     marginTop: theme.spacing(1),
//     padding: theme.spacing(1),
//     backgroundColor: "#ffffff",
//     justifyContent: "space-around",
//   },
//   typographyClass: {
//     fontFamily: "'Cairo'",
//   },
//   typographyGeneralClass: {
//     fontFamily: "'Cairo'",
//     color: "#000000",
//   },

//   whiteSpace: {
//     fontFamily: "'Cairo'",
//     color: "#ffffff",
//   },
//   containerHeader: {
//     backgroundColor: "#f5f5f5",
//   },
//   innerContainerHeader: {
//     paddingTop: theme.spacing(1),
//     // paddingBottom: theme.spacing(1),

//     justifyContent: "space-around",
//     backgroundColor: "#f5f5f5",
//   },
//   firstColumnHeader: {
//     borderRadius: "5px 5px 0px 0px",
//     fontWeight: 600,
//     margin: "0 auto",
//     textAlign: "center",
//     backgroundColor: "#e7e8e8",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     color: "#2e6b95",
//   },
//   secondColumnHeader: {
//     borderRadius: "5px 5px 0px 0px",
//     fontWeight: 600,
//     margin: "0 auto",
//     textAlign: "center",
//     backgroundColor: "#e7e8e8",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     color: "#2e6b95",
//   },
//   thirdColumnHeader: {
//     borderRadius: "5px 5px 0px 0px",
//     textAlign: "center",
//     fontWeight: 600,
//     margin: "0 auto",
//     height: "auto",
//     backgroundColor: "#e7e8e8",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     color: "#2e6b95",
//   },

//   fourthColumnHeader: {
//     borderRadius: "5px 5px 0px 0px",
//     backgroundColor: "#e7e8e8",
//     textAlign: "center",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     fontWeight: 600,
//     margin: "0 auto",
//     color: "#2e6b95",
//   },

//   generalColumnHeader: {
//     borderRadius: "5px 5px 0px 0px",
//     backgroundColor: "#e7e8e8",
//     textAlign: "center",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     fontWeight: 600,
//     margin: "0 auto",
//     color: "#2e6b95",
//   },

//   ColumnHeaders: {
//     textAlign: "center",
//     fontWeight: 600,

//     margin: "0 auto",
//   },

//   container: {
//     height: "auto",
//     justifyContent: "center",
//     backgroundColor: "#f5f5f5",
//   },
//   innerContainer: {
//     // paddingTop: theme.spacing(1),
//     paddingBottom: theme.spacing(1),
//     height: "auto",
//     justifyContent: "space-around",
//     backgroundColor: "#f5f5f5",
//   },
//   firstColumn: {
//     borderRadius: "0px 0px 5px 5px",
//     padding: "15px",
//     backgroundColor: "#ffffff",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//   },
//   secondColumn: {
//     borderRadius: "0px 0px 5px 5px",
//     padding: "15px",
//     backgroundColor: "#ffffff",
//     boxShadow: "3px 3px  rgba(0, 0, 0, 0.1)",
//   },
//   thirdColumn: {
//     borderRadius: "0px 0px 5px 5px",
//     textAlign: "left",
//     padding: "15px",
//     backgroundColor: "#ffffff",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//   },
//   thirdSub1Column: {
//     borderRadius: "0px 0px 0px 0px",
//     textAlign: "left",
//     padding: "0px",
//     backgroundColor: "#ffffff",
//     // boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//   },
//   thirdSub2Column: {
//     borderRadius: "0px 0px 0px 0px",
//     textAlign: "center",
//     padding: "0px",
//     backgroundColor: "#ffffff",
//     // boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//   },
//   thirdSub3Column: {
//     borderRadius: "0px 0px 0px 0px",
//     textAlign: "left",
//     padding: "0px",
//     backgroundColor: "#ffffff",
//     // boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//   },
//   fourthColumn: {
//     borderRadius: "0px 0px 5px 5px",
//     backgroundColor: "#ffffff",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     padding: "15px",
//   },

//   generalColumn: {
//     // borderRadius:'0px 0px 5px 5px',
//     backgroundColor: "#ffffff",
//     boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
//     padding: "15px",
//   },

//   inner: {
//     height: "125px",
//     width: "250px",
//     border: "1px solid black",
//     borderRadius: "10%",
//     margin: "0 auto",
//     background: "#3f51b5",
//   },

//   mostInner: {
//     textAlign: "center",
//     height: "85px",
//     width: "200px",
//     border: "1px solid black",
//     borderRadius: "50px",
//     marginTop: "10px",
//     marginLeft: "25px",
//     marginRight: "25px",
//     // boxShadow:"0px 0px 31px 2px #0083b3,inset 0px 0px 31px 2px #0083b3",
//     //  textShadow:"0 0 5px #d4e3fa,  0 0 10px #d4e3fa, 0 0 7px #fff,  0 0 20px #8fb8f7, 0 0 35px #8fb8f7, 0 0 40px #8fb8f7, 0 0 50px #8fb8f7,  0 0 75px #8fb8f7",
//     // background: "repeatingLinear-gradient(45deg,transparent,transparent 4px, #171717 4px, black 8px), linearGradient(to bottom, #171717, black)",
//     background: "#f2f7ff",
//     backgroundRepeat: "no-repeat",
//     backgroundAttachment: "fixed",
//   },

//   time: {
//     color: "black",
//     fontSize: "35px",
//     position: "relative",
//     display: "block",
//     marginTop: "22px",
//   },

//   amPm: {
//     position: "relative",
//     display: "block",
//     width: "10px",
//     marginLeft: "150px",
//     marginTop: "-5px",
//     color: "black",
//     fontSize: "12px",
//   },
// }));

const cookies = new Cookies();
function ViewAllUnits(props) {
  // const myRef = React.createRef();
  // const classes = useStyles();
  const [state, setState] = React.useState({
    value: {
      verified: "",
      data: [],
      Usersdata: [],
      Users: [],
      check: "login",
      name: "",
      spin: false,
    },
  });
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [showImages, setShowImage] = React.useState(false);

  const exportToCSV = (csvData, fileName) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    if (csvData && csvData.length > 0) {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + '_' + Math.floor(Date.now() / 1000) + fileExtension);
    }
 }
  const handleExportFunction=()=>{
    let arr=[]
    props?.units&&props?.units?.length&&props?.units?.map((itm,index)=>{
        arr.push({
            '#':index+1,
            'Request type':props?.request_type_name,
            'Request Date':props?.created_at?helpers.formatDate(props?.created_at):'0000-00-00',
            'Task Name':itm?.name,
            'Task Reason':itm?.reason,
            'Account Name':props?.account_name,
            'User Name':props?.user_name
        })
    })
    exportToCSV(arr,'TasksUnits')

  }


  return (
    <Dialog
      fullScreen
      open={props.isShown}
      onClose={props.closeShowAllUnits}
      TransitionComponent={Transition}
    >
      <AppBar 
      // className={classes.appBar}
      sx={{
        backgroundColor:'#1e6a99',
       }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={props.closeShowAllUnits}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" 
          // className={classes.title}
          >
            All Units Informations
          </Typography>
      
        </Toolbar>
     
      </AppBar>
      <Box 
      sx={{
            width:'90%',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            alignSelf:'center',
            flexDirection:'column',
            marginTop:'90px',
            '& .table':{
            captionSide: 'bottom !important',
             borderCollapse: 'collapse !important'
          },
          '& .td':{
            borderRight: '0 !important',
            borderLeft: '0 !important',
          }
        }}>
        <div 
          style={{
            width:'100%',
            height:'50px',
            backgroundColor:props?.dashboardMode?'#132A3B':'#2e6b95',
            margin:'10px 0',
            // borderRadius:'5px'
            display:'flex',
            alignItems:'center',
            justifyContent:'space-between'
          }}
        >
            <div
             style={{
              margin:'0 10px 0 10px',
             }}
            >
                <div
                 style={{
                    backgroundColor:'#fff',
                    borderRadius:'50%',
                    width:'35px',
                    height:'35px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems:'center',
                    boxShadow:'0 0 10px -3px #fff',
                    cursor:'pointer'
                 }}
                 onClick={handleExportFunction}
                >
                   <HtmlTooltip
                      title={
                          <React.Fragment>
                              <Typography color="inherit" style={{fontFamily:'Cairo'}}>تصدير</Typography>
                          </React.Fragment>
                      }
                  >
                      <div 
                        style={{
                          display:'felx',
                          justifyContent:'center',
                          alignItems:'center',
                        }}
                      >
                      <CgIcons.CgExport style={{
                              fontSize:'25px',
                              color:'#000',
                              position:'relative',
                              top:'-1px',
                              left:'-1px'
                          }}/>
                      </div>
                  </HtmlTooltip>
             
                </div>
            </div>
            <div>
                <div style={{
                    width:'fit-content',height:'30px',display:'flex',justifyContent:'center',alignItems:'center',
                    backgroundColor:'#fff',
                    color:'#000',
                    padding:'0  15px',
                    margin:'0 10px',
                    borderRadius:'5px'
                    }}>
                    <span style={{margin:'0 2px'}}>{props?.units?.length}</span>
                    <span style={{fontWeight:'bold'}}>: عدد الوحدات</span>
                    
                </div>
            </div>

        </div>
        <Table  bordered hover className="roundedUnitsTable">
            <thead >
              <tr style={{
                backgroundColor:props?.dashboardMode?'#132A3B':'#2e6b95',
                color:'#fff'
              }}>
                <th>#</th>
                <th>T.ID</th>
                <th>Unit Name</th>
                <th>Unit Reason</th>

              </tr>
            </thead>
            <tbody>
                {
                 props?.units&&props?.units?.length>0?props?.units?.map((itm,index)=>{
                    return<tr>
                        <td>{index+1}</td>
                        <td>{itm?.task_id}</td>
                        <td>{itm?.name}</td>
                        <td>{itm?.reason}</td>
                    </tr>
                }):
                <tr>
                    <td colSpan={4} style={{textAlign:'center'}}>Theres No Data</td>
                </tr>
                }
            
            </tbody>
          </Table>
          </Box>

    </Dialog>
  );
}
export default ViewAllUnits;
